import { apiCall, API } from '../../utils/APIFunctions';

export function searchObjects(params) {
  return apiCall(`${API}/elasticsearch/objects/search?q=${params.q}&size=${params.size}&from=${params.from}`, "GET");
}